export default __webpack_public_path__ + "static/media/ps1.f3e382f0.jpg";